<template>
  <el-dialog title="Alege ajutor montator disponibil" id="popup_ajutor_montator_dialog" :visible.sync="showPopup" class="my-dialog-class">
    <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
      ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
      <el-row :gutter="15">
        <el-col class="input-element">
          <el-form-item label="Ajutor montator" prop="IdAjutorMontator">
            <el-select v-model="selectedObject.IdAjutorMontator" class="full-width">
              <el-option label="Fara ajutor" value="-1"></el-option>
              <el-option v-for="item in ajutorMontatori" :key="item.Id" :label="item.Nume" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Ajutor_montator_dialog",
  extends: BasePage,
  data() {
    return {
      showPopup: false,
      selectedObject: {
        IdAjutorMontator: null,
      },
      rules: {
        IdAjutorMontator: [{ required: false, message: "" }],
      },
      ajutorMontatori: [],
    };
  },

  methods: {
    show_me: async function (ajutorMontatori) {
      this.showPopup = true;
      this.selectedObject.IdAjutorMontator = null;
      this.ajutorMontatori = ajutorMontatori || [];
    },
    save: async function () {
        this.$emit("save", this.selectedObject.IdAjutorMontator);
        this.showPopup = false
    },
  },
  mounted() { }
};
</script>

<style lang="less" scoped></style>